import { render, staticRenderFns } from "./BookmarkDetailModal.vue?vue&type=template&id=d4ce4cf2&"
import script from "./BookmarkDetailModal.vue?vue&type=script&lang=js&"
export * from "./BookmarkDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports